import { Helmet } from 'react-helmet-async';
// sections
import { TourGuideItemView } from 'src/sections/tourGuide/view';

// ----------------------------------------------------------------------

export default function TourGuideItemConfigurePage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Item Configure tour guide</title>
      </Helmet>

      <TourGuideItemView />
    </>
  );
}
